<template>
  <div style="min-width: 1380px">
    <div class="home">
      <div
        class="home_top"
        :class="{ scrolled: isScrolled }"
        :style="{ color: textColor }"
      >
      <div class="home-container">
        <div class="home_top_text">
          <img
            v-if="textColor != 'black'"
            src="@/assets/img/logo-white.png"
            alt=""
            srcset=""
          />
          <img v-else src="@/assets/img/logo-purple.png" alt="" srcset="" />
          <div :style="{ color: textColor }">数字鲸鱼</div>
        </div>
        <div class="home_top_home">
          <div class="nav-item" :class="{ 'is-active': active == '' }" @click="goPage('')" :style="{ color: textColor }">
            首页
            <div class="nav-indicator" :style="{ background: textColor }"></div>
          </div>
          <div class="nav-item" :class="{ 'is-active': active == 'electricPower' }" @click="goPage('electricPower')" :style="{ color: textColor }">
            电力行业
            <div class="nav-indicator" :style="{ background: textColor }"></div>
          </div>
          <div class="nav-item" :class="{ 'is-active': active == 'publishing' }" @click="goPage('publishing')" :style="{ color: textColor }">
            出版行业
            <div class="nav-indicator" :style="{ background: textColor }"></div>
          </div>
          <div class="nav-item" :class="{ 'is-active': active == 'about' }" @click="goPage('about')" :style="{ color: textColor }">
            关于鲸鱼
            <div class="nav-indicator" :style="{ background: textColor }"></div>
          </div>
          <div class="nav-item" :class="{ 'is-active': active == 'connect' }" @click="goPage('connect')" :style="{ color: textColor }">
            联系我们
            <div class="nav-indicator" :style="{ background: textColor }"></div>
          </div>
        </div>
      </div>
      </div>
      <div class="first-part-container">
        <div class="content">
          <div class="labe-desc1">{{ pageData.firstPart.desc1 }}</div>
          <div class="labe-desc2">
            <span v-if="bannerIndex == 0">{{
              pageData.firstPart.descbanner1
            }}</span>
            <span v-if="bannerIndex == 1">{{
              pageData.firstPart.descbanner2
            }}</span>
            <span v-if="bannerIndex == 2">{{
              pageData.firstPart.descbanner3
            }}</span>
            <span v-if="bannerIndex == 3">{{
              pageData.firstPart.descbanner4
            }}</span>
            <span v-if="bannerIndex == 4">{{
              pageData.firstPart.descbanner5
            }}</span>
          </div>
          <div class="labe-desc3">{{ pageData.firstPart.desc3 }}</div>
        </div>
        <div class="homeimgbgc">
          <div v-for="(item, index) in pageData.firstPart.list" :key="index">
            <div class="roll">
              <Roll class="num" v-if="bannerIndex == 0" :end="item.bannerNum1" />
              <Roll class="num" v-if="bannerIndex == 1" :end="item.bannerNum2" />
              <Roll class="num" v-if="bannerIndex == 2" :end="item.bannerNum3" />
              <Roll class="num" v-if="bannerIndex == 3" :end="item.bannerNum4" />
              <Roll class="num" v-if="bannerIndex == 4" :end="item.bannerNum5" />
              <div class="unit">{{ item.unit }}</div>
            </div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="bg-gray" style="width: 100%; height:200px;background: rgba(0,0,0,0.40);position: absolute;bottom: 0;left: 0;z-index: 2;"></div>
      <el-carousel
        @change="changeCarousel"
        class="custom-carousel"
        :autoplay="false"
        trigger="click"
      >
        <el-carousel-item
          v-for="(item, index) in pageData.firstPart.videoList"
          :key="index"
        >
          <div class="video-container">
            <video
              :src="item.video"
              controls
              autoplay
              loop
              muted
              id="myVideo"
              ref="videoRef"
            ></video>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="briefintroduction">
      <div class="second-part-container">
      <div class="briefintroduction_title">
        <span>{{ pageData.secondPart.title1 }}</span>
        <span>{{ pageData.secondPart.title2 }}</span>
      </div>
      <div class="briefintroduction_strip"></div>
      <div class="briefintroduction_xiaotitle">
        {{ pageData.secondPart.titleEnglish }}
      </div>
      <div class="briefintroduction_text">
        {{ pageData.secondPart.describe }}
      </div>
      <div class="briefintroduction_button">
        <span>查看详情</span>
        <img src="@/assets/img/details-icon.png" alt="" srcset="" />
      </div>
      <div class="briefintroduction_company"></div>
      <div class="briefintroduction_establish">成立于</div>
      <div class="briefintroduction_year">
        <span>{{ pageData.secondPart.year }}</span>
        <span>年</span>
      </div>
      <div class="briefintroduction_img-box">
        <div class="briefintroduction_img">
          <div class="carousel-container">
            <div class="carousel-wrapper">
              <div
                class="carousel"
                :style="{ transform: `translateX(${translateValue}px)` }"
                ref="carousel"
              >
                <div
                  class="carousel-item"
                  v-for="(item, index) in pageData.secondPart.imgList"
                  :key="index"
                >
                  <div class="card">
                    <img
                      :src="item.img"
                      class="card-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="prev-button" @click="slidePrev"><i class="el-icon-back"></i></button>
        <button class="next-button" @click="slideNext"><i class="el-icon-right"></i></button>
      </div>
      </div>
    </div>
    <div class="ProductServices">

      <div class="third-part-container">
        <div
          class="ProductServices_button"
          ref="myButton"
          @mouseenter="pause"
          @mouseleave="resume"
        >
          <div
            class="ProductServices_index"
            :class="val == 1 ? 'buttonindex' : ''"
            @click="ProductServicesbutton('1')"
          >
            <div
              :class="
                val == 1 ? 'ProductServices_shiround' : 'ProductServices_xuround'
              "
            ></div>
          </div>
          <br /><br />
          <div
            class="ProductServices_index"
            :class="val == 2 ? 'buttonindex' : ''"
            @click="ProductServicesbutton('2')"
          >
            <div
              :class="
                val == 2 ? 'ProductServices_shiround' : 'ProductServices_xuround'
              "
            ></div>
          </div>
          <br /><br />
          <div
            class="ProductServices_index"
            :class="val == 3 ? 'buttonindex' : ''"
            @click="ProductServicesbutton('3')"
          >
            <div
              :class="
                val == 3 ? 'ProductServices_shiround' : 'ProductServices_xuround'
              "
            ></div>
          </div>
          <br /><br />
          <div
            class="ProductServices_index"
            :class="val == 4 ? 'buttonindex' : ''"
            @click="ProductServicesbutton('4')"
          >
            <div
              :class="
                val == 4 ? 'ProductServices_shiround' : 'ProductServices_xuround'
              "
            ></div>
          </div>
          <br /><br />
          <div
            class="ProductServices_index"
            :class="val == 5 ? 'buttonindex' : ''"
            @click="ProductServicesbutton('5')"
          >
            <div
              :class="
                val == 5 ? 'ProductServices_shiround' : 'ProductServices_xuround'
              "
            ></div>
          </div>
        </div>
        <!-- 标题 -->
        <div class="ProductServices_title">
          <span>{{ pageData.thirdPart.title1 }}</span>
          <span>{{ pageData.thirdPart.title2 }}</span>
          <span>{{ pageData.thirdPart.title3 }}</span>
        </div>
        <div class="ProductServices_strip"></div>
        <div class="ProductServices_Eltitle">
          {{ pageData.thirdPart.titleEnglish }}
        </div>
        <!-- 内容 -->
        <div
          class="ProductServices_conter"
          v-for="(item, index) in pageData.thirdPart.list"
          :key="index"
          v-show="val == index + 1"
        >
          <div class="ProductServices_contertitle">
            <div></div>
            <div>{{ item.label }}</div>
          </div>
          <div class="ProductServices_contertext">
            {{ item.content }}
          </div>
          <div class="ProductServices_contertextbutton">
            <span>查看详情</span>
            <img src="@/assets/img/details-icon.png" alt="" srcset="" />
          </div>
          <div class="ProductServices_conterimger">
            <img :src="item.iconUrl" alt="" srcset="" />
          </div>
        </div>
      </div>
    </div>
    <div class="ServiceCases">
      <div class="ServiceCases_tltle">服务案例</div>
      <div class="ServiceCases_img">
        <div class="index">
          <vue-seamless-scroll
            :data="pageData.fourthPart.imageList1"
            :class-option="classOption"
          >
            <div slot="default" class="scroll-list">
              <div
                class="li"
                v-for="(item, index) in pageData.fourthPart.imageList1"
                :key="index"
              >
                <img :src="item" alt="" srcset="" />
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="index02">
          <vue-seamless-scroll
            :data="pageData.fourthPart.imageList2"
            :class-option="classOption1"
          >
            <div slot="default" class="scroll-list">
              <div
                class="li"
                v-for="(item, index) in pageData.fourthPart.imageList2"
                :key="index"
              >
                <img :src="item" alt="" srcset="" />
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
        <div class="index03">
          <vue-seamless-scroll
            :data="pageData.fourthPart.imageList3"
            :class-option="classOption"
          >
            <div slot="default" class="scroll-list">
              <div
                class="li"
                v-for="(item, index) in pageData.fourthPart.imageList3"
                :key="index"
              >
                <img :src="item" alt="" srcset="" />
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
    <div class="Solution">
      <div class="five-part-container">
        <div class="Solution_title">{{ pageData.fivePart.title }}</div>
        <div class="Solution_Eltitle">
          {{ pageData.fivePart.describe }}
        </div>
        <div class="Solution_conter">
          <div class="Solution_conter_img">
            <img
              v-if="value == 1"
              :src="pageData.fivePart.img1"
              alt=""
              srcset=""
            />
            <img
              v-if="value == 2"
              :src="pageData.fivePart.img2"
              alt=""
              srcset=""
            />
            <img
              v-if="value == 3"
              :src="pageData.fivePart.img3"
              alt=""
              srcset=""
            />
          </div>
          <div class="Solution_conter_text">
            <div
              class="Solution_conter_text_botton"
              :class="value == 1 ? 'Solution_bgc' : ''"
              @click="Solution('1')"
            >
              <img src="@/assets/img/home/image 73.png" alt="" srcset="" />
              <div class="Solution_conter_text_botton_titlt">
                {{ pageData.fivePart.label1 }}
              </div>
              <div class="Solution_conter_text_botton_suijhys"></div>
            </div>
            <div
              class="Solution_conter_text_botton"
              :class="value == 2 ? 'Solution_bgc' : ''"
              @click="Solution('2')"
            >
              <img src="@/assets/img/home/image75.png" alt="" srcset="" />
              <div class="Solution_conter_text_botton_titlt">
                {{ pageData.fivePart.label2 }}
              </div>
              <div class="Solution_conter_text_botton_suijhys"></div>
            </div>
            <div
              class="Solution_conter_text_botton"
              :class="value == 3 ? 'Solution_bgc' : ''"
              @click="Solution('3')"
            >
              <img src="@/assets/img/home/image74.png" alt="" srcset="" />
              <div class="Solution_conter_text_botton_titlt">
                {{ pageData.fivePart.label3 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bomment">
      <div class="six-part-container">
        <div class="bomment_title">{{ pageData.sixPart.title }}</div>
        <div class="bomment_ELtitle">
          {{ pageData.sixPart.describe }}
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import VueSeamlessScroll from "vue-seamless-scroll";
import Footer from "./components/footer.vue";
import jsonData from "../../../public/static/text.json";
export default {
  name: "HomeView",
  components: { Footer, VueSeamlessScroll },
  computed: {
    textColor() {
      return this.isScrolled ? "black" : "white";
    },
    classOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    classOption1() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 3, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    return {
      val: 1, // 产品与服务切换
      value: 1, // 解决方案切换
      isScrolled: false,
      curIndex: 0,
      curIndex02: 0,
      curIndex03: 0,
      translateValue: 0,
      containerWidth: 0,
      itemWidth: 0,
      gap: 20,
      inter: null,
      inter2: null,
      inter3: null,
      interval: null,
      active: "",
      pageData: {},
      bannerIndex: 0,
    };
  },
  mounted() {
    this.containerWidth = this.$el.offsetWidth;
    this.itemWidth = this.containerWidth / 3; // 每次显示3张图片
    window.addEventListener("scroll", this.handleScroll);
    this.ProductServices();
    // setTimeout(() => {
    // this.images[0] = require("@/assets/img/home/循环.webm");
    // }, 5000);
    //刚进页面回到顶部
    window.scrollTo({ top: 0, behavior: 'smooth'});
  },
  created() {
    this.pageData = jsonData.oneData;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.interval);
  },
  methods: {
    // 切换banner页
    changeCarousel(index) {
      this.bannerIndex = index;
    },
    goPage(val) {
      this.active = val;
      if (this.$route.path == "/" + val) {
        return;
      }
      this.$router.push("/" + val);
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 800;
    },
    resume() {
      this.ProductServices();
    },
    pause() {
      clearInterval(this.interval);
    },
    ProductServices() {
      this.interval = setInterval(() => {
        this.val++;
        if (this.val > 5) {
          this.val = 1;
        }
      }, 3000);
    },
    startRoll03() {
      this.inter3 = setInterval(this.handleNextRoll03, 3000);
    },
    init03() {
      let bannerEl = document.querySelector(".banner03");
      this.curIndex03++;
      bannerEl.style.transform = `translateX(-${this.curIndex * 100}%)`;
      this.startRoll03();
    },
    handleNextRoll03() {
      let bannerEl = document.querySelector(".banner03");
      this.curIndex03++;
      bannerEl.style.transform = `translateX(-${this.curIndex03 * 100}%)`;
      bannerEl.style.transition = `all 3s linear`;
      if (this.curIndex03 === this.imgList03.length - 3) {
        let list = this.imgList03.concat(this.imgList03);
        this.imgList03 = list;
        this.curIndex03++;
        bannerEl.style.transform = `translateX(-${this.curIndex * 100}%)`;
      }
    },
    ProductServicesbutton(val) {
      // 产品与服务切换
      this.val = val;
    },
    Solution(value) {
      // 解决方案切换
      this.value = value;
    },
    slidePrev() {
      if (this.translateValue < 0) {
        this.translateValue += this.itemWidth + this.gap;
        if (this.translateValue > 0) {
          this.translateValue = 0;
        }
      }
    },
    slideNext() {
      const maxTranslate = -(
        this.pageData.secondPart.imgList.length *
          (this.itemWidth + this.gap - 100) -
        this.containerWidth
      );
      if (this.translateValue > maxTranslate) {
        this.translateValue -= this.itemWidth + this.gap;
        if (this.translateValue < maxTranslate) {
          this.translateValue = maxTranslate;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  height: 228px;
  margin: auto;
  overflow: hidden;
  margin-bottom: 20px;

  .scroll-list {
    overflow: hidden;
    display: flex;

    .li {
      width: 441px;
      height: 228px;
      margin-left: 20px;

      > img {
        width: 441px;
        height: 228px;
      }
    }
  }
}
.index03 {
  width: 100%;
  height: 228px;
  margin: auto;
  overflow: hidden;

  .scroll-list {
    overflow: hidden;
    display: flex;

    .li {
      width: 441px;
      height: 228px;
      margin-left: 20px;

      >img {
        width: 441px;
        height: 228px;
      }
    }
  }
}
.index02 {
  width: calc(1920px + 13.5%);
  height: 228px;
  margin: auto;
  overflow: hidden;
  transform: translateX(-12%);
  margin-bottom: 20px;

  .scroll-list {
    overflow: hidden;
    display: flex;

    .li {
      width: 441px;
      height: 228px;
      margin-left: 20px;

      >img {
        width: 441px;
        height: 228px;
      }
    }
  }
}
.home {
  width: 100%;
  height: 970px;
  position: relative;
  user-select: none;
  ::v-deep .el-carousel {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;

    .el-carousel__container {
      height: 100%;
      width: 100%;
    }

    .video-container {
      position: relative;
      width: 100%;
      height: 100%;
      padding-bottom: 56.25%;
      /* 设置视频容器的宽高比，这里使用16:9的宽高比 */
    }

    .video-container video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      /* 视频充满容器 */
    }

    .video-container video::-webkit-media-controls {
      display: none;
      /* 隐藏浏览器默认的视频控件 */
    }
  }
  .first-part-container {
    width: 1380px;
    height: 970px;
    margin: 0 auto;
    padding: 0 50px;
    overflow-x: auto;
    min-width: 1380px;
    position: absolute;
    left: calc(50% - 690px);
    top: 0;
    z-index: 3;
    pointer-events: none;
    .content {
      color: #ffffff;
      margin-top: 250px;
      text-align: left;
      .labe-desc1 {
        font-size: 60px;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-800";
        letter-spacing: 4px;
        color: #ffffff;
        height: 80px;
        line-height: 80px;
      }
      .labe-desc2 {
        font-size: 100px;
        font-family: "HYYaKuHei, HYYaKuHei-700";
        font-weight: 700;
        letter-spacing: 4px;
        color: #ffffff;
      }
      .labe-desc3 {
        padding-top: 40px;
        font-size: 32px;
        font-family: "Alibaba PuHuiTi 2, Alibaba PuHuiTi 2-500";
        letter-spacing: 4px;
        color: #ffffff;
        line-height: 48px;
      }
    }
    .homeimgbgc {
      height: 200px;
      // background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #ffffff;
      margin-top: 232px;
      .roll {
        display: flex;
        width: 120px;
        align-items: flex-end;
      }
      .num {
        height: 80px;
        font-size: 80px;
        font-family: "Anton, Anton-400";
        font-weight: 400;
        color: #ffffff;
        line-height: 80px;
        letter-spacing: 0.4px;
        margin-right: 5px;
      }
      .unit {
        font-size: 32px;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-500";
        color: #ffffff;
      }
      .label {
        font-size: 30px;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
        font-weight: normal;
        text-align: LEFT;
        color: #ffffff;
        line-height: 40px;
        text-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
        padding-top: 10px;
      }
      .homeimgbgc_conterer {
        width: 45px;
        height: 80px;
        font-size: 90px;
        font-family: "Anton, Anton-400";
        font-weight: 700;
        color: #ffffff;
        line-height: 80px;
        letter-spacing: 0.45px;
      }

      .homeimgbgc_conteres {
        width: 32px;
        height: 60px;
        font-size: 32px;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-500";
        font-weight: 400;
        color: #ffffff;
        line-height: 48px;
      }

      .homeimgbgc_conter01 {
        position: absolute;
        left: 320px;
        top: 40px;
      }

      .homeimgbgc_conter02 {
        position: absolute;
        left: 380px;
        top: 73px;
      }

      .homeimgbgc_conter03 {
        position: absolute;
        left: 635.5px;
        top: 40px;
      }

      .homeimgbgc_conter04 {
        position: absolute;
        left: 730.67px;
        top: 73px;
      }

      .homeimgbgc_conter05 {
        position: absolute;
        left: 977.33px;
        top: 40px;
      }

      .homeimgbgc_conter06 {
        position: absolute;
        left: 1120.33px;
        top: 73px;
      }

      .homeimgbgc_conter07 {
        position: absolute;
        left: 1399px;
        top: 40px;
      }

      .homeimgbgc_conter08 {
        position: absolute;
        left: 1537px;
        top: 73px;
      }

      .homeimgbgc_text {
        width: 119px;
        height: 40px;
        font-size: 24px;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
        color: #ffffff;
        font-weight: 400;
        line-height: 40px;
        text-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
      }

      .homeimgbgc_text01 {
        position: absolute;
        left: 320px;
        top: 130px;
      }

      .homeimgbgc_text02 {
        position: absolute;
        left: 635.67px;
        top: 130px;
      }

      .homeimgbgc_text03 {
        position: absolute;
        left: 990.33px;
        top: 130px;
      }

      .homeimgbgc_text04 {
        position: absolute;
        left: 1410px;
        top: 130px;
      }
    }
  }
  /deep/ .el-carousel__indicators {
    // 指示灯位置
    transform: unset;
    left: calc(50% - 640px);
    top: 665px;
  }

  /deep/ .el-carousel__button {
    // 默认按钮的颜色大小等
    width: 60px;
    height: 4px;
    border: none;
    border-radius: 20px;
    background: #e2e2e2;
    opacity: 1;
  }

  /deep/ .is-active .el-carousel__button {
    // 选中图片的颜色
    background: #782088;
    opacity: 1;
  }

  /deep/ .el-carousel-item {
    display: inline-block;
    width: 100px;
    /* 调整图片宽度 */
    margin: 0 10px;
    /* 调整图片之间的空隙 */
    vertical-align: top;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .scrolled {
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .home_top {
    width: 100%;
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    transition: background-color 0.3s, box-shadow 0.3s;
    .home-container {
      width: 1380px;
      height: 100px;
      min-width: 1380px;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

    .home_top_text {
      width: 230px;
      height: 60px;
      display: flex;
      margin-top: 20px;

      img {
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }

      div {
        width: 160px;
        height: 60px;
        font-size: 40px;
        font-family: "HYYaKuHei, HYYaKuHei-700";
        font-weight: 700;
        text-align: LEFT;
        color: #ffffff;
        line-height: 60px;
      }
    }

    .home_top_home {
      width: 620px;
      height: 60px;
      display: flex;
      color: #ffffff;
      margin-top: 30px;
      justify-content: space-between;

      > .nav-item {
        position: relative;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        cursor: pointer;
        white-space: nowrap;

        > .nav-indicator {
          position: absolute;
          width: 20px;
          height: 4px;
          border-radius: 40px;
          bottom: 0px;
          left: 50%;
          opacity: 0;
          transform: translateX(-50%);
        }

        &.is-active > .nav-indicator {
          opacity: 1;
        }
      }
    }
  }
  }
}

.briefintroduction {
  width: 100%;
  height: 800px;
  background-image: url("../../../public/home/homebg2.png");
  background-size: 100% 100%;
  user-select: none;
  
  
  .second-part-container {
    width: 1380px;
    height: 800px;
    padding: 0 50px;
    margin: 0 auto;
    position: relative;
    // background-color: #fff;
    text-align: left;
    overflow-x: auto;
    min-width: 1380px;
    &::before {
      content: "";
      display: table;
      clear: both;
    }
  .briefintroduction_title {
    width: 360px;
    height: 60px;
    font-size: 60px;
    font-family: "HYYaKuHei, HYYaKuHei-700";
    font-weight: 700;
    line-height: 60px;
    margin-top: 100px;

    span:nth-child(1) {
      color: #333333;
    }

    span:nth-child(2) {
      color: #782088;
    }
  }

  .briefintroduction_strip {
    width: 400px;
    height: 2px;
    background: #d7d7fa;
    margin-top: 20px;
  }

  .briefintroduction_xiaotitle {
    height: 40px;
    font-weight: 400;
    font-size: 36px;
    color: #c9c9ed;
    line-height: 40px;
    margin-top: 20px;
  }

  .briefintroduction_text {
    width: 800px;
    height: 192px;
    font-size: 20px;
    font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
    color: #333333;
    line-height: 32px;
    margin-top: 30px;
  }

  .briefintroduction_button {
    width: 150px;
    height: 40px;
    background: #8d0aa5;
    border-radius: 30px;
    text-align: center;
    margin-top: 46px;

    >span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
      font-size: 20px;
    }

    >img {
      width: 25px;
      height: 24px;
      vertical-align: middle;
    }
  }

  .briefintroduction_company {
    width: 621px;
    height: 560px;
    position: absolute;
    bottom: 0;
    right: 0;
    background-image: url("../../../public/home/company.png");
    background-size: 100% 100%;
  }

  .briefintroduction_establish {
    width: 60px;
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    color: #262a36;
    font-weight: 400;
    position: absolute;
    top: 180px;
    right: 109px;
  }

  .briefintroduction_year {
    position: absolute;
    top: 220px;
    right: 50px;

    span:nth-child(1) {
      color: #782088;
      width: 109px;
      font-family: "Anton, Anton-400";
      height: 60px;
      font-size: 60px;
      font-weight: 400;
      line-height: 60px;
    }

    span:nth-child(2) {
      color: #782088;
      width: 20px;
      height: 24px;
      font-size: 20px;
      font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
      font-weight: normal;
      line-height: 24px;
    }
  }
  .briefintroduction_img-box {
    width: 590px;
    height: 140px;
    overflow: hidden;
    margin-top: 50px;
    padding-left: 15px;
    position: relative;
  .briefintroduction_img {
    width: 560px;
    height: 140px;
    overflow: hidden;
    // margin-top: 50px;
    

    .carousel-wrapper {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .carousel {
      display: flex;
      transition: transform 0.3s ease;
    }

    .carousel-item {
      flex-shrink: 0;
      margin-right: 20px;
    }

    .card {
      width: 190px;
      height: 140px;
    }

    .card-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    // background-color: #782088;
  }
  
  .prev-button,
    .next-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 20px;
      background: none;
      cursor: pointer;
      // padding: 5px 10px;
      background-color: #ffffff;
      border-radius: 50%;
      box-shadow: 0px 1.25px 5px 0px rgba(0,0,0,0.20);
      color:  #c9c9ed;
      font-size: 16px;
    }

    .prev-button {
      left: 0px;
    }

    .next-button {
      right: 0px;
    }
}
  }
}

.ProductServices {
  width: 100%;
  height: 800px;
  position: relative;
  background-image: url("../../../public/home/homebg3.png");
  background-size: 100% 100%;
  text-align: left;
  user-select: none;
  .third-part-container {
      width: 1380px;
      height: 800px;
      padding: 0 50px;
      margin: 0 auto;
      position: relative;
      text-align: left;
      min-width: 1380px;
      overflow-x: auto;
      &::before {
    content: "";
    display: table;
    clear: both;
  }
  .ProductServices_title {
    width: 312px;
    height: 60px;
    font-family: "HYYaKuHei, HYYaKuHei-700";
    font-weight: 700;
    color: #ffffff;
    line-height: 60px;
    font-size: 60px;
    margin-top: 100px;

    span:nth-child(2) {
      color: #782088;
    }
  }

  .ProductServices_strip {
    width: 460px;
    height: 2px;
    margin-top: 20px;
    background-color: #782088;
  }

  .ProductServices_Eltitle {
    height: 40px;
    font-size: 36px;
    font-family: "Bakbak One, Bakbak One-400";
    font-weight: 400;
    color: #453d4e;
    line-height: 40px;
    margin-top: 20px;
  }

  .ProductServices_button {
    position: absolute;
    left: 50px;
    top: 342px;
    z-index: 100;

    .buttonindex {
      border: 1px solid #722ed1;
      border-radius: 50%;
    }

    .ProductServices_index {
      width: 14px;
      height: 14px;
      cursor: pointer;
      padding: 3px;
      box-sizing: border-box;
    }

    .ProductServices_shiround {
      width: 6px;
      height: 6px;
      background: #722ed1;
      border-radius: 50%;
    }

    .ProductServices_xuround {
      width: 6px;
      height: 6px;
      background: #5a5e67;
      border-radius: 50%;
    }
  }

  .ProductServices_conter {
    width: 100%;
    height: 498px;
    padding-left: 50px;
    .ProductServices_contertitle {
      width: 400px;
      height: 60px;
      display: flex;
      margin-top: 60px;

      div:nth-child(1) {
        margin-top: 10px;
        height: 40px;
        width: 5px;
        background: linear-gradient(0deg, #722ed1 0%, #782088);
        border-radius: 30px;
      }

      div:nth-child(2) {
        // width: 380px;
        height: 60px;
        font-size: 42px;
        margin-left: 10px;
        font-family: "HYYaKuHei, HYYaKuHei-700";
        color: #ffffff;
        line-height: 60px;
      }
    }

    .ProductServices_contertext {
      width: 480px;
      height: 118px;
      font-size: 20px;
      text-align: left;
      font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
      color: #ffffff;
      line-height: 32px;
      margin-top: 30px;
    }

    .ProductServices_contertextbutton {
      width: 150px;
      height: 40px;
      background: #8d0aa5;
      border-radius: 30px;
      text-align: center;
      margin-top: 90px;

      span {
        display: inline-block;
        // width: 79px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-250";
        font-size: 20px;
      }

      img {
        width: 25px;
        height: 24px;
        vertical-align: middle;
      }
    }
  }

  .ProductServices_conterimger {
    width: 600px;
    height: 360px;
    background-image: url("../../../public/home/outlinebg.png");
    background-size: 100% 100%;
    position: absolute;
    top: 260px;
    right: 50px;
    box-sizing: border-box;
    padding: 30px 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  }
}

.ServiceCases {
  width: 100%;
  height: 1044px;
  background-image: url("../../../public/home/homebg4.png");
  background-size: 100% 100%;
  position: relative;

  .ServiceCases_tltle {
    width: 192px;
    height: 60px;
    font-size: 48px;
    font-family: "HYYaKuHei, HYYaKuHei-700";
    font-weight: 700;
    text-align: LEFT;
    color: #333333;
    position: absolute;
    line-height: 60px;
    top: 100px;
    left: 864px;
  }

  .ServiceCases_img {
    width: 100%;
    height: 735px;
    position: absolute;
    top: 220px;
    overflow: hidden;

    .container01 {
      height: 228px;
      overflow: hidden;
      width: 100%;

      .banner01 {
        width: 441px;
        height: 228px;
        display: flex;

        .banner-img01 {
          width: 441px;
          height: 228px;
          margin-left: 20px;
        }
      }
    }

    .container02 {
      height: 228px;
      width: 100%;
      margin-top: 20px;

      // transform: translateX(-12%);
      // overflow: hidden;
      .banner02 {
        width: 441px;
        height: 228px;
        display: flex;

        .banner-img02 {
          width: 441px;
          height: 228px;
          margin-left: 20px;
        }
      }
    }

    .container03 {
      height: 228px;
      width: 100%;
      margin-top: 20px;

      // overflow: hidden;
      .banner03 {
        width: 441px;
        height: 228px;
        display: flex;

        .banner-img03 {
          width: 441px;
          height: 228px;
          margin-left: 20px;
        }
      }
    }
  }
}

.Solution {
  width: 100%;
  height: 1020px;
  background: linear-gradient(110deg,#0a081f 0%, #242d5d 100%);
  user-select: none;

  .five-part-container {
    width: 1380px;
    height: 1020px;
    padding: 0 50px;
    margin: 0 auto;
    position: relative;
    overflow-x: auto;
    min-width: 1380px;
    &::before {
      content: "";
      display: table;
      clear: both;
    }
  .Solution_title {
    height: 60px;
    font-size: 48px;
    font-family: "HYYaKuHei, HYYaKuHei-700";
    font-weight: 700;
    color: #ffffff;
    line-height: 60px;
    margin-top: 100px;
  }

  .Solution_Eltitle {
    height: 30px;
    font-size: 20px;
    font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-500";
    font-weight: 500;
    color: #72727d;
    line-height: 30px;
    margin-top: 10px;
  }

  .Solution_conter {
    width: 1260px;
    height: 660px;
    border: 1px solid #626181;
    margin-top: 60px;

    .Solution_conter_img {
      height: 520px;
      width: 1261px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .Solution_conter_text {
      width: 100%;
      height: 140px;
      display: flex;

      .Solution_bgc {
        border-bottom: 5px solid #782088;
        background: linear-gradient(
          82deg,
          #0e1014 0%,
          #1b4a85 70%,
          #1d4275 77%,
          #152540 100%
        );
      }

      .Solution_conter_text_botton {
        width: 420px;
        height: 140px;
        cursor: pointer;
        position: relative;

        img {
          position: absolute;
          left: 119.5px;
          top: 45px;
          width: 50px;
          height: 50px;
        }

        .Solution_conter_text_botton_titlt {
          position: absolute;
          width: 120px;
          height: 40px;
          font-size: 24px;
          font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
          font-weight: 400;
          text-align: CENTER;
          color: #ffffff;
          line-height: 40px;
          left: 180px;
          top: 50px;
        }

        .Solution_conter_text_botton_suijhys {
          width: 1px;
          height: 100px;
          background: #405098;
          position: absolute;
          left: 419px;
          top: 20px;
        }
      }
    }
  }
  }
}

.bomment {
  width: 100%;
  height: 250px;
  background-image: url("../../../public/home/homebg6.png");
  background-size: 100% 100%;
  user-select: none;
  .six-part-container {
    width: 1380px;
    height: 250px;
    padding: 0 50px;
    margin: 0 auto;
    overflow-x: auto;
    min-width: 1380px;
    &::before {
      content: "";
      display: table;
      clear: both;
    }

  .bomment_title {
    height: 40px;
    font-size: 40px;
    font-family: "HYYaKuHei, HYYaKuHei-700";
    color: #ffffff;
    line-height: 40px;
    letter-spacing: 0.4px;
    margin-top: 70px;
  }

  .bomment_ELtitle {
    height: 40px;
    font-size: 24px;
    font-family: "Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-400";
    color: #ffffff;
    line-height: 40px;
    margin-top: 20px;
  }
  }
}
</style>
